module.exports = __webpack_public_path__ + "img/salary.4c7de560.svg";